<template>
  <section>
    <div v-if="loading" class="customer-list-info">
      <div class="loader">
      </div>
    </div>
    <div v-else-if="selectedAccount" class="row">
      <div class="col-md-12">
        <h5 class="mt-3">Selected Account: <small v-if="selectedAccount">{{selectedAccount.name}}</small></h5>
        <button class="btn btn-outline-primary pull-right" @click="inviteUser">Invite New User</button>

        <table id="job-log-datatable" class="table table-striped table-bordered w-100">
          <thead>
          <tr>
            <th>Email</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
          </thead>
          <tbody>
          <template v-if="allMembers.length">
            <tr v-for="(row, index) in allMembers" :key="index">
              <td>{{ row.user.email }}</td>
              <td>{{ row.status }}</td>
              <td><button type="button" class="btn text-light btn-link bg-danger mr-1" :disabled="loading" @click="deleteMember(row)">
                Delete
              </button></td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="3">
                <p class="text-center">No members exist!</p>

              </td>
            </tr>
          </template>

          </tbody>
        </table>
      </div>
    </div>
    <div v-else-if="!loading && !selectedAccount" class="p-3 text-danger">
      Please Select Account
    </div>
    <inviteUserModal ref="inviteUserModal"></inviteUserModal>
  </section>

</template>

<script>
import swal from "sweetalert2";

export default {
  name: "index",
  components: {
    inviteUserModal: () =>
        import(/* webpackChunkName: "userList" */ "./inviteUserModal"),
  },
  props: {
    selectedAccount: {
      type: Object
    }
  },
  data() {
    return {
      allMembers: [],
      loading: false
    }
  },
  watch: {
    selectedAccount(val) {
      if(val){
        this.getAllMembers()
      }
    }
  },
  mounted(){
    this.getAllMembers()
  },
  methods: {
    async deleteMember(row){
      try{
        this.loading= true
        let resp = await this.$http.post('tenant/delete-member',{
          grant_type:'token',
          accountId: this.selectedAccount.id,
          memberId: row.id
        });

        console.log(resp)
        await this.getAllMembers()
        swal({
          title: "Success!",
          text: "You have successfully deleted member.",
          type: "success"
        })
      }catch (e) {
        console.log('Error from deleting member to account' + e.toString())
        swal({
          title: "Error!",
          text: "Something went wrong while deleting member",
          type: "error"
        })
      } finally {
        this.loading=false
      }
    },
    inviteUser(){
      this.$refs.inviteUserModal.load(this.selectedAccount)
    },
    async getAllMembers(){
      try{
        this.allMembers= []
        this.loading= true
        let resp = await this.$http.post('tenant/list-members-under-account',{
          grant_type:'token',
          accountId: this.selectedAccount.id
        });
        console.log('members', resp.data)
        const tenant = 'cloudflare@bigscoots.com'
        this.allMembers = resp.data.result.filter((userInfo) => {
          return userInfo.user.email !== tenant && !userInfo.user.email.includes('@bigscoots-wpo.com')
        });

      }catch (e) {
        console.log('Error from fetching all membeers under account' + e.toString())
      } finally {
        this.loading=false
      }
    }
  }
}
</script>

<style scoped>

</style>